import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import dsaWithCppImage from '../../images/cardpageimages/technicalcourse/dsawithcpp.jpg';
import IntroVideos from "../../componants/introvideos";
import DsaWithCppModule from "../../componants/allCourseModule/TechnicalCourseModule/DsaWithCppModule";

function DsaWithCpp() {
  return (
    <>
      <Header />
      <BannerForAll
        title="DSA WITH C++ FULL COURSE"
        text="Our DSA with C++ Full Course provides a detailed introduction to data structures and algorithms using C++. Covering essential concepts like arrays, linked lists, stacks, queues, trees, graphs, and sorting algorithms, this course is perfect for anyone looking to improve problem-solving skills and strengthen their programming foundation. With C++ as the primary language, gain in-depth knowledge to succeed in technical interviews and competitive programming."
        imageone={dsaWithCppImage}
        imagetwo={dsaWithCppImage}
      />
      <IntroVideos
        vone="https://www.youtube.com/embed/dQw4w9WgXcQ"
        vtwo="https://www.youtube.com/embed/3JZ_D3ELwOQ"
        topic="DSA WITH C++"
      />
      <DsaWithCppModule />
      <Footer />
    </>
  );
}

export default DsaWithCpp;
